
const LessonsHero = () => {
  return (
    <section 
      className="relative min-h-[70vh] flex items-center justify-center bg-cover bg-center bg-no-repeat"
      style={{
        backgroundImage: `linear-gradient(rgba(99, 102, 241, 0.1), rgba(99, 102, 241, 0.1)), url('https://public.readdy.ai/ai/img_res/287a6503a8d95d5b898e3b968c037b30.jpg')`
      }}
    >
      <div className="container mx-auto px-4 py-20">
        <div className="max-w-4xl mx-auto text-center">
          <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6 leading-tight">
            Get Personal Guidance with 
            <span className="text-indigo-600"> One-on-One Lessons</span>
          </h1>
          <p className="text-xl md:text-2xl text-gray-700 mb-8 leading-relaxed">
            Sometimes you need that extra push or personalized feedback. Book a private video lesson with me 
            and get the individual attention that will accelerate your English learning journey.
          </p>
          
          <div className="bg-white/90 backdrop-blur-sm rounded-2xl p-8 shadow-lg max-w-2xl mx-auto">
            <div className="flex items-center justify-center space-x-8 mb-6">
              <div className="text-center">
                <div className="text-3xl font-bold text-indigo-600">€20</div>
                <div className="text-gray-600">per session</div>
              </div>
              <div className="w-px h-12 bg-gray-300"></div>
              <div className="text-center">
                <div className="text-3xl font-bold text-indigo-600">60</div>
                <div className="text-gray-600">minutes</div>
              </div>
              <div className="w-px h-12 bg-gray-300"></div>
              <div className="text-center">
                <div className="text-3xl font-bold text-indigo-600">1:1</div>
                <div className="text-gray-600">personal</div>
              </div>
            </div>
            
            <button 
              onClick={() => document.getElementById('booking-section')?.scrollIntoView({ behavior: 'smooth' })}
              className="bg-indigo-600 text-white px-8 py-4 rounded-lg text-lg font-semibold hover:bg-indigo-700 transition-colors shadow-lg whitespace-nowrap cursor-pointer"
            >
              <i className="ri-calendar-line mr-2"></i>
              Book Your Lesson Now
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default LessonsHero;
